/**
 * Returns a function which takes a single argument and passes it through
 * the given functions
 */
export default <Arg>(
    ...functions: Array<(val: Arg, ...rest) => Arg>
  ): ((val: Arg) => Arg) =>
  (initialValue: Arg): Arg =>
    functions.reduce((val, func) => func(val), initialValue);
